import type { DeclarationTVA } from './DeclarationTVAService';

/**
 * Export e-TVA au format DGI Gabon (XML).
 * Format simplifié, conforme aux spécifications de la déclaration en ligne.
 */
export class ETVAExporter {
  static genererXML(declaration: DeclarationTVA, nif: string, raison_sociale: string): string {
    const esc = (s: string): string =>
      s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    return `<?xml version="1.0" encoding="UTF-8"?>
<DeclarationTVA xmlns="http://dgi.ga/etva/v1">
  <Entete>
    <NIF>${esc(nif)}</NIF>
    <RaisonSociale>${esc(raison_sociale)}</RaisonSociale>
    <Periode>${declaration.periode}</Periode>
  </Entete>
  <Operations>
    <TVACollectee>${declaration.tva_collectee}</TVACollectee>
    <TVADeductibleBiens>${declaration.tva_deductible_biens}</TVADeductibleBiens>
    <TVADeductibleImmobilisations>${declaration.tva_deductible_immo}</TVADeductibleImmobilisations>
    <CreditAnterieur>${declaration.credit_anterieur}</CreditAnterieur>
  </Operations>
  <Solde>
    <TVADue>${declaration.tva_due}</TVADue>
    <CreditReportable>${declaration.credit_reportable}</CreditReportable>
  </Solde>
</DeclarationTVA>`;
  }
}
